import React from 'react';

import { Button } from '@/components';

import styles from './styles.module.scss';

interface Props {
  children: React.ReactNode;
}

const LoginGateBlock = ({ children }: Props) => (
  <div className={styles.loginGateBlock}>
    <h4>{children}</h4>
    <Button href="/login" design="highlight" size="large">
      Sign in
    </Button>
    <span>
      New member? <a href="/activate">Activate your card now</a>
    </span>
  </div>
);

export default LoginGateBlock;
